import { UserPermission } from '../../types/authTypes'

export const isKwlMAPermission = (permissions: Array<UserPermission>) =>
	permissions.find(permission => permission.key === 'KWL_Master_Agent')

export const isRBZReportPermission= (permissions: Array<UserPermission>) => 
  permissions.find(permission => permission.key === 'KWL_RBZ_Report')
